import React from "react";

function Four404(){
    return(
        <div>
<section className="internal_wraper">
<div className="container">
<div className="row">
    <div className="col-12 mt-5 pt-5">
<h1 className="font-weight-bold">
404
page not found!
</h1>
    </div>
</div>
</div>
</section>
        </div>
    );
};

export default Four404;